"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
let uid = 0;
/**
 * Ritorna un numerio incrementale
 *
 * @param {number} [from=0]
 * @returns {number}
 */
exports.newId = (from = 0) => ++uid + from;
/**
 * Ritorna stringa di almeno due cifre
 *
 * @param {number} n
 * @returns {string}
 */
exports.twoDigits = (n) => (n <= 9 ? '0' : '') + n;
/**
 * Ritorna un valore compreso tra 0 ed 1
 *
 * @param {number} value
 * @returns {number}
 */
exports.clamp01 = (value) => exports.clamp(0, 1, value);
/**
 * Ritorna un valore compreso tra {min} ed {max}
 *
 * @param {number} min
 * @param {number} max
 * @param {number} value
 * @returns {number}
 */
exports.clamp = (min, max, value) => value <= min ? min : (value >= max ? max : value);
/**
 * Ritorna un valore compreso tra {min} e {max} in rifermiento a {refMin} e {refMax}
 *
 * @example
 * ```javascript
 * relativeClamp2(0.5, 0, 1, 100, 200) // 150
 * ```
 *
 * @param {number} value
 * @param {number} refMin
 * @param {number} refMax
 * @param {number} toMin
 * @param {number} toMax
 * @returns {number}
 */
exports.relativeClamp = (value, refMin, refMax, toMin, toMax) => exports.clamp(toMin, toMax, (value - refMin) / (refMax - refMin) * (toMax - toMin) + toMin);
/**
 * Ritorna un numero approssimato alla cifra {decimal}
 *
 * @param {*} value
 * @param {number} [decimal=20]
 * @returns {number}
 */
exports.fix = (value, decimal = 20) => +parseFloat(value).toFixed(decimal);
/**
 * Ritorna il prossimo numero di una lista
 *
 * @example
 * ```javascript
 * console.log(2, 3) // 0
 * ```
 *
 * @param {number} index
 * @param {number} length
 * @param {number} [offset=1]
 * @returns
 */
exports.nextNumber = (index, length, offset = 1) => (index + offset) % length;
/**
 * Ritorna il valore precedente di una lista
 * @example
 * ```javascript
 *
 * console.log(0, 3) // 2
 * ```
 *
 * @param {number} index
 * @param {number} length
 * @param {number} [offset=1]
 * @returns
 */
exports.prevNumber = (index, length, offset = 1) => {
    index -= offset;
    return (index < 0 ? index + length : index) % length;
};
/**
 * Ritorna un numero random tra {min} e {max}
 *
 * @param {number} min
 * @param {number} max
 * @returns {number}
 */
exports.randomFloat = (min, max) => Math.random() * (max - min) + min;
/**
 * Ritorna un numero intero tra {min} e {max} (inclusi)
 *
 * @param {number} min
 * @param {number} max
 * @returns {number}
 */
exports.randomInt = (min, max) => Math.trunc(Math.random() * (max - min + 1)) + min;
/**
 * Funzione lerp
 *
 * @param {number} value1
 * @param {number} value2
 * @param {number} amount
 * @returns {number}
 */
exports.lerp = (value1, value2, amount) => value1 + (value2 - value1) * exports.clamp01(amount);
/**
 * Round
 *
 * @param {number} val
 * @returns {number}
 */
exports.round = (val) => ~~(val + 0.5);
//# sourceMappingURL=Number.js.map